export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/project-list/:pageId',
        component: () => import('@/views/page/company/procurement/project/List.vue'),
        name: 'project-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/project-add/:pageId',
        component: () => import('@/views/page/company/procurement/project/Add.vue'),
        name: 'project-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/project-edit/:pageId/:projectId',
        component: () => import('@/views/page/company/procurement/project/Add.vue'),
        name: 'project-edit',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/project-register/:pageId',
        component: () => import('@/views/page/company/procurement/project/register/Index.vue'),
        name: 'project-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/beneficiary-register/:pageId',
        component: () => import('@/views/page/company/procurement/beneficiary/register/Index.vue'),
        name: 'beneficiary-register',
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/beneficiary-dashboard/:pageId',
        component: () => import('@/views/page/company/procurement/beneficiary/dashboard/List.vue'),
        name: 'beneficiary-dashboard',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/beneficiary-dashboard-details/:pageId',
        component: () => import('@/views/page/company/procurement/beneficiary/dashboard/Details.vue'),
        name: 'beneficiary-dashboard-details',
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/beneficiary-profile/:pageId',
        component: () => import('@/views/page/company/procurement/beneficiary/List.vue'),
        name: 'beneficiary-profile',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/add-beneficiary/:pageId',
        component: () => import('@/views/page/company/procurement/beneficiary/Add.vue'),
        name: 'add-beneficiary',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/crm-stage-summary/:pageId',
        component: () => import('@/views/page/company/admin/crm-stage/List.vue'),
        name: 'crm-stage-summary',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/shareholder-register/:pageId',
        component: () => import('@/views/page/company/procurement/shareholder-register/register/Index.vue'),
        name: 'shareholder-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/shareholder-profile/:pageId',
        component: () => import('@/views/page/company/procurement/shareholder-register/List.vue'),
        name: 'shareholder-profile',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/add-shareholder/:pageId',
        component: () => import('@/views/page/company/procurement/shareholder-register/Add.vue'),
        name: 'add-shareholder',
        meta: {
            requiresAuth: true
        }
    },
]
